import { getImage } from "@/utils/data/image";
import { default as NextImage } from "next/image";

type Props = {
  id: string;
  classImage?: string;
  type?: "normal" | "background";
  height?: number;
  priority?: boolean;
};

export default function Img({
  id,
  classImage,
  type = "normal",
  height,
  priority,
}: Props) {
  const image = getImage(id);

  if (!image) {
    return null;
  }

  const w = height ? (image.width * height) / image.height : image.width;
  const h = height || image.height;
  const style = height
    ? { width: "auto", minWidth: w, minHeight: height }
    : undefined;

  if (type === "background") {
    return (
      <div className="-z-1 flex items-center absolute -inset-4">
        <NextImage
          className={`${classImage || ""} object-cover w-full h-full blur-xs`}
          src={image.src}
          alt={image.alt}
          width={w}
          height={h}
          style={style}
          priority={priority}
        />
      </div>
    );
  } else {
    return (
      <NextImage
        className={classImage}
        src={image.src}
        alt={image.alt}
        width={w}
        height={h}
        style={style}
        priority={priority}
      />
    );
  }
}
